const routes = [
  {
    path: "/contabilidade/gastos",
    component: () => import("@/views/dashboard/gastos/Gastos.vue"),
    meta: {
      menu: "dashboard",
      title: { text: "global.gasto", plural: true },
      icon: "mdi-chart-box-plus-outline",
      breadcrumb: [
        { text: "global.home", to: { path: "/" } },
        { text: "global.gasto", plural: true },
      ],
      permission: { componente: "Gastos" },
    },
  },
];

export default routes;
